import React from "react";

const DangerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6669 12.6667H3.3802H3.33353C3.12113 12.6557 2.91443 12.5941 2.73068 12.487C2.54694 12.3799 2.39148 12.2304 2.2773 12.0509C2.16311 11.8715 2.09351 11.6673 2.0743 11.4555C2.05509 11.2437 2.08683 11.0304 2.16687 10.8333L6.83353 2.66666C6.94884 2.45826 7.11786 2.28454 7.32303 2.16358C7.5282 2.04262 7.76203 1.97882 8.0002 1.97882C8.23837 1.97882 8.4722 2.04262 8.67737 2.16358C8.88254 2.28454 9.05156 2.45826 9.16687 2.66666L13.8335 10.8333C13.9136 11.0304 13.9453 11.2437 13.9261 11.4555C13.9069 11.6673 13.8373 11.8715 13.7231 12.0509C13.6089 12.2304 13.4535 12.3799 13.2697 12.487C13.086 12.5941 12.8793 12.6557 12.6669 12.6667ZM8.75 6C8.75 5.58579 8.41421 5.25 8 5.25C7.58579 5.25 7.25 5.58579 7.25 6V7.33333C7.25 7.74755 7.58579 8.08333 8 8.08333C8.41421 8.08333 8.75 7.74755 8.75 7.33333V6ZM8.75 10C8.75 9.58579 8.41421 9.25 8 9.25C7.58579 9.25 7.25 9.58579 7.25 10V10.0067C7.25 10.4209 7.58579 10.7567 8 10.7567C8.41421 10.7567 8.75 10.4209 8.75 10.0067V10Z"
        fill="#EA6B3D"
      />
    </svg>
  );
};

export default DangerIcon;
